<template>
  <div>
    <div v-if="isMobile" class="d-flex align-items-center p-2 bg-light shadow-sm sticky-top">
      <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
        <b-icon-list></b-icon-list>
      </b-button>
      <span class="font-weight-bold">{{ activeTabTitle }}</span>
    </div>

    <b-sidebar
      id="vendororders-drawer"
      title="Vendor Orders"
      shadow
      bg-variant="light"
      text-variant="dark"
      :visible="drawerOpen"
      @hidden="drawerOpen = false"
      backdrop
      placement="left"
    >
      <hr/>
      <ul class="list-unstyled m-0">
        <li v-for="(tab, index) in filteredTabs" :key="index" class="mb-2">
          <b-button
            block
            squared
            :variant="activeTabIndex === index ? null : 'link'"
            class="text-left"
            @click="selectTab(index)"
          >
            <b-icon :icon="tab.icon" class="mr-2"></b-icon>
            {{ tab.title }}
          </b-button>
        </li>
      </ul>
    </b-sidebar>

    <div v-if="!isMobile">
    

      <b-tabs card lazy v-model="activeTabIndex">
           <b-tab
          v-if="['admin','officemanager','warehousemanager','warehouseuser'].includes(packet.userDetails.userrole)"
          title="CONTAINER ORDERS"
          style="padding: 5px;"
        >
          <ListContainerOrders />
        </b-tab>
        
        <b-tab title="STOCK VENDOR ORDERS" style="padding: 5px;">
          <ListStockOrders />
        </b-tab>

           <b-tab title="CUSTOMER VENDOR ORDERS">
          <ListCustomerBackOrders />
        </b-tab>

       
        <b-tab
          v-if="['admin', 'officemanager'].includes(packet.userDetails.userrole)"
          title="PROCESS SPECIAL ORDERS"
        >
          <ListCustomerOrders />
        </b-tab>
          <b-tab
          v-if="['admin', 'officemanager'].includes(packet.userDetails.userrole)"
          title="LOW INVENTORY ORDERS"
        >
          <ListLowInventory />
        </b-tab>

          <b-tab
          v-if="['admin', 'officemanager'].includes(packet.userDetails.userrole)"
          title="LOW INVENTORY BACKORDERS"
        >
          <ListLowInventoryPO />
        </b-tab>

     

        <b-tab title="VENDOR ORDERS LOGS">
          <VendorOrdersLogs />
        </b-tab>
      </b-tabs>
    </div>

    <div v-if="isMobile" class="mt-2">
      <keep-alive>
        <component v-if="activeTabComponent" :is="activeTabComponent"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import {
  BIconList,
  BIconBox,
  BIconClipboard,
  BIconTruck,
  BIconFileText,
  BIconArchive
} from 'bootstrap-vue';

import ItemComments from '@/components/importables/ItemComments';
import ListContainerOrders from '@/components/VendorOrders/ListContainerOrders';
import ListStockOrders from '@/components/VendorOrders/ListStockOrders';
import ListCustomerOrders from '@/components/VendorOrders/ListCustomerOrders';
import ListCustomerBackOrders from '@/components/VendorOrders/ListCustomerBackOrders.vue';
import VendorOrdersLogs from '@/components/VendorOrders/VendorOrdersLogs.vue';
import ListLowInventory from '@/components/VendorOrders/ListLowInventory.vue';
import ListLowInventoryPO from '@/components/VendorOrders/ListLowInventoryPO.vue';

export default {
  name: "VendorOrdersMain",
  components: {
    ItemComments,
    ListContainerOrders,
    ListStockOrders,
    ListCustomerOrders,
    ListCustomerBackOrders,
    VendorOrdersLogs,
    ListLowInventory,
    ListLowInventoryPO,
    BIconList,
    BIconBox,
    BIconClipboard,
    BIconTruck,
    BIconFileText,
    BIconArchive
  },
  data() {
    return {
      drawerOpen: false,
      activeTabIndex: 0,
      isMobile: false,
      packet: { userDetails: {} },
      tabs: [
        {
          title: 'DOMESTIC ORDERS',
          icon: 'box',
          roles: ['admin', 'officemanager', 'officeuser', 'salesperson'],
          component: 'ListStockOrders'
        },
        {
          title: 'CONTAINER ORDERS',
          icon: 'truck',
          roles: ['admin'],
          component: 'ListContainerOrders'
        },
        {
          title: 'PROCESS CUSTOMER ORDERS',
          icon: 'clipboard',
          roles: ['admin', 'officemanager'],
          component: 'ListCustomerOrders'
        },
         {
          title: 'LOW INVENTORY ORDERS',
          icon: 'clipboard',
          roles: ['admin', 'officemanager'],
          component: 'ListLowInventory'
        },
         {
          title: 'LOW INVENTORY BACKORDERS',
          icon: 'clipboard',
          roles: ['admin', 'officemanager'],
          component: 'ListLowInventoryPO'
        },
        {
          title: 'CUSTOMER VENDOR ORDERS',
          icon: 'file-text',
          roles: ['admin','officeuser','officemanager','locationadmin','locationstockperson','warehouseuser','warehousemanager'],
          component: 'ListCustomerBackOrders'
        },
        {
          title: 'VENDOR ORDERS LOGS',
          icon: 'archive',
          roles: ['admin','officeuser','officemanager','locationadmin','locationstockperson','warehouseuser','warehousemanager'],
          component: 'VendorOrdersLogs'
        }
      ]
    };
  },
  computed: {
    filteredTabs() {
      const role = this.packet.userDetails.userrole || '';
      return this.tabs.filter(tab => tab.roles.includes(role));
    },
    activeTabTitle() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.title : 'Menu';
    },
    activeTabComponent() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.component : null;
    }
  },
  methods: {
    selectTab(index) {
      this.activeTabIndex = index;
      this.drawerOpen = false;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    initializeUserDetails() {
      try {
        this.packet = JSON.parse(localStorage.packet || '{}');
        this.packet.userDetails = JSON.parse(localStorage.userDetails || '{}');
      } catch (e) {
        console.error('Error reading user data:', e);
      }
    }
  },
  created() {
    this.initializeUserDetails();
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .b-tabs {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VendorOrders/VendorOrdersMain.vue